export const SCHEDULE_PATTERNS = {
  onceOff: { id: 'ONCE_OFF', label: 'onceOff' },
  simpleInterval: { id: 'SIMPLE_INTERVAL', label: 'simpleInterval' },
  weekly: { id: 'WEEKLY_SCHEDULE', label: 'weekly' },
  dateOfMonth: { id: 'MONTHLY_SCHEDULE_BY_DATES', label: 'dateOfMonth' },
  dayOfMonth: { id: 'MONTHLY_SCHEDULE_BY_DAY', label: 'dayOfMonth' },
};

export const SCHEDULE_CONSTANTS = {
  allProviders: 'All Providers',
};
